<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>

  <span translate>COMMONS.PRODUCTS</span>
</div>

<tb-header specificTitle="COMMONS.PRODUCTS" parentPage="productsdownload"></tb-header>

<div class="contentGlobal" style="text-align: left">
  <div class="cards-grid-container">
    <div class="card-wrapper" *ngFor="let product of getProductsCard()">
      <ms-product-card [product]="product"></ms-product-card>
    </div>
  </div>
</div>

<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>

